<template>
    <div class="card shadow">
        <div class="card-header text-center bg-primary">
            Mes nouvelles taches
        </div>
        <div class="card-body p-0">
            <div class="todos-container">
                <div v-if="todos.length > 0">
                    <div v-for="todo in todos" :key="todo.id">
                        <b-card
                            bg-variant="light"
                            no-body
                            class="text-dark p-2 mb-3 shadow-sm"
                        >
                            <div class="row">
                                <div class="col-10">
                                    <b-link
                                        title="Accéder à la fiche client"
                                        @click="
                                            goToClientHome(todo.client.uuid)
                                        "
                                    >
                                        <p class="todo-client">
                                            {{ todo.client.name }}
                                        </p>
                                    </b-link>
                                </div>
                                <div class="col-2 text-right">
                                    <priority-handler
                                        :key="'ph' + todo.id"
                                        :priority="todo.priority"
                                    />
                                </div>
                            </div>

                            <p class="todo-created">
                                {{ todo.created_at_for_humans }} par
                                {{ todo.created_by.name }}
                            </p>
                            <hr class="mb-1 mt-1" />
                            <b-link
                                title="Afficher la todo"
                                @click="goToTask(todo)"
                            >
                                <p class="todo-description">
                                    {{ todo.description }}
                                </p>
                            </b-link>
                            <p class="todo-deadline">
                                Echéance :
                                {{ todo.deadline_date | moment('D/M/Y') }}
                            </p>
                        </b-card>
                    </div>
                </div>
                <div v-else>
                    <b-card
                        bg-variant="light"
                        no-body
                        class="text-dark p-2 mb-3 shadow-sm"
                    >
                        <p class="comment-description">
                            Aucune nouvelle tâche ne vous a été affectée
                        </p>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PriorityHandler from '../../common/components/PriorityHandler.vue'

export default {
    name: 'HomeNewToDos',

    components: {
        PriorityHandler,
    },

    props: {
        todoRoute: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            todos: [],
        }
    },

    async created() {
        await this.getTodos()
    },

    methods: {
        async getTodos() {
            try {
                const response = await this.$axios.get('/todo/home')
                this.todos = response.data.data
            } catch (error) {
                // console.log(error)
            }
        },

        goToTask(task) {
            this.$store.commit('browsing/SKIP_INIT')
            this.$store.commit('browsing/SET_TODO_FILTER', 'undone')
            this.$store.commit('browsing/SET_EDITING')
            this.$store.commit('browsing/SET_PAGE_NAME', 'tasks.edit')
            this.$store.commit('data/SET_EDITED_TASK', task)
            window.location.href = this.todoRoute
        },

        goToClientHome(uuid) {
            window.location.href = `pilotage-activite/clients/${uuid}/accueil`
        },
    },
}
</script>

<style scoped>
.todos-container {
    background-color: white !important;
    padding: 15px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 562px;
}

.todo-client {
    font-weight: bold;
    margin-bottom: 0;
    margin-top: 0;
}

.todo-description {
    margin-bottom: 0;
}

.todo-created {
    font-size: 11px;
    margin-bottom: 0;
    font-style: italic;
}

.todo-deadline {
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 0;
}
</style>
